import { Center, Text } from '@chakra-ui/react';
import * as React from 'react';

export const NotAllowedToViewContent: React.FC = () => {
  return (
    <Center>
      <Text>You are not allowed to view this content.</Text>
    </Center>
  );
};
